import { BooleanFilterViewModel } from "../../columnFilter/booleanFilter/booleanFilter-viewModel";
import { DateFilterViewModel } from "../../columnFilter/dateFilter/dateFilter-viewModel";
import { EnumFilterViewModel } from "../../columnFilter/enumFilter/enumFilter-viewModel";
import { NumericFilterViewModel } from "../../columnFilter/numericFilter/numericFilter-viewModel";
import { StringFilterViewModel } from "../../columnFilter/stringFilter/stringFilter-viewModel";
import { ColumnViewModel } from "../column-viewModel";
import { BooleanColumnSort, DateColumnSort, EnumColumnSort, NumericColumnSort, StringColumnSort } from "../../sorting/columnSort";
import { IColumnVisitor } from "../columnVisitor";
import { Enum } from "../../../enum";
import { ViewModel } from "binder";

export class BooleanColumnViewModel extends ColumnViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filter = new BooleanFilterViewModel(this);
        this.columnSort = new BooleanColumnSort();
        this.filter.column = this;
        this.columnSort.column = this;
    }
    
    public getTypeId(): string {
        return "VM-390E41BB-ACCE-40F0-A7E1-CEC37C1B86CB";
    }
    accept(visitor: IColumnVisitor, parameter: any) {
        return visitor.visitBooleanColumn(this,parameter);
    }

    public set filterlabel(v: string) { 
        (<BooleanFilterViewModel>this.filter).text = v;
    } public get filterlabel(): string { 
        return (<BooleanFilterViewModel>this.filter).text;
    }
    
}

export class DateColumnViewModel extends ColumnViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filter = new DateFilterViewModel(this);
        this.columnSort = new DateColumnSort();
        this.filter.column = this;
        this.columnSort.column = this;
    }
    
    public getTypeId(): string {
        return "VM-DA35B13F-FF57-4104-8B0B-9A9E2EDF74FB";
    }
    accept(visitor: IColumnVisitor, parameter: any) {
        return visitor.visitDateColumn(this,parameter);
    }
}

export class EnumColumnViewModel extends ColumnViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filter = new EnumFilterViewModel(this);
        this.columnSort = new EnumColumnSort();
        this.filter.column = this;
        this.columnSort.column = this;
    }
    
    public getTypeId(): string {
        return "VM-AC3D760E-C706-40AD-8770-EFD2048FA4CD";
    }

    accept(visitor: IColumnVisitor, parameter: any) {
        return visitor.visitEnumColumn(this,parameter);
    }

    public set enumprovider(v: Enum) { 
        this._enumprovider = v; 
        (<EnumFilterViewModel>this.filter).enumProvider = v;
    } public get enumprovider(): Enum { return this._enumprovider;} private _enumprovider: Enum;


}

export class NumericColumnViewModel extends ColumnViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filter = new NumericFilterViewModel(this);
        this.columnSort = new NumericColumnSort();
        this.filter.column = this;
        this.columnSort.column = this;
    }
    
    public getTypeId(): string {
        return "VM-90BB742A-E6A5-40E5-A814-D916E5BD25F4";
    }

    accept(visitor: IColumnVisitor, parameter: any) {
        return visitor.visitNumericColumn(this,parameter);
    }
}

export class StringColumnViewModel extends ColumnViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filter = new StringFilterViewModel(this);
        this.columnSort = new StringColumnSort();
        this.filter.column = this;
        this.columnSort.column = this;
    }
    
    public getTypeId(): string {
        return "VM-68F38417-3F09-4F83-9526-B0A70FAE30BE";
    }

    accept(visitor: IColumnVisitor, parameter: any) {
        return visitor.visitStringColumn(this,parameter);
    }
}
